<div style="margin-top: 24px">
    <ng-container *ngIf="+gruppe?.standard === 0">
        <button *kienePermission="[1912]" mat-flat-button color="accent" (click)="openGruppeInformationenDialog()">
            <mat-icon>edit_note</mat-icon>
            <span>&nbsp;Informationen hinzufügen</span>
        </button>
    </ng-container>
</div>

<mat-expansion-panel style="margin-top: 24px" [expanded]="true">
    <mat-expansion-panel-header>
        <mat-panel-title>
            <div style="display: inline-flex">
                <mat-icon>info</mat-icon>
                <span style="margin-left: 6px; padding-top: 4px">Gruppendetails</span>
            </div>
        </mat-panel-title>
    </mat-expansion-panel-header>

    <table aria-label="gruppen-infos">
        <tr>
            <td class="tdlabel">Anzahl Tiere: </td>
            <td class="tdvalue">{{ gruppe?.anzahl_tiere_gesamt || "---" }} </td>
            <td class="tdlabel">Abgänge: </td>
            <td class="tdvalue"
                >{{ gruppe?.anzahl_abgaenge || "---" }}
                {{ getDifferenceString(gruppe?.anzahl_abgaenge, gruppe?.anzahl_tiere_gesamt, { asPercentage: true }) }}
            </td>
            <td class="tdlabel">Tote: </td>
            <td class="tdvalue"
                >{{ gruppe?.anzahl_tote || "---" }}
                {{ getDifferenceString(gruppe?.anzahl_tote, gruppe?.anzahl_tiere_gesamt, { asPercentage: true }) }}
            </td>
            <td class="tdlabel">Anzahl Tiere aktuell: </td>
            <td class="tdvalue">{{ gruppe?.anzahl_tiere_aktuell || "---" }} </td>
        </tr>

        <tr>
            <td class="tdlabel">Standort: </td>
            <td class="tdvalue">{{ gruppe?.stall || "---" }} </td>
            <td class="tdlabel">Einstalldatum: </td>
            <td class="tdvalue">
                {{ (gruppe?.einstalldatum_von | date: "dd.MM.yy") || "---" }}
            </td>
            <td class="tdlabel">Akt. Produktionsabschnitt:</td>
            <td class="tdvalue"
                >{{ gruppe?.produktionsabschnitt || "---" }} seit
                {{ (gruppe?.datum_von | date: "dd.MM.yy") || "---" }}
            </td>
        </tr>

        <tr>
            <td class="tdlabel">Informationen:</td>
            <td class="tdvalue" colspan="7">{{ gruppe?.informationen || "---" }}</td>
        </tr>
    </table>
</mat-expansion-panel>
<mat-expansion-panel style="margin-top: 24px" [expanded]="true">
    <mat-expansion-panel-header>
        <mat-panel-title>
            <div style="display: inline-flex">
                <mat-icon>history</mat-icon>
                <span style="margin-left: 6px; padding-top: 4px">Verlauf</span>
            </div>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <ul style="list-style-type: none">
        <li *ngFor="let gb of gruppenBewegungen">
            <div class="one-row">
                <span style="margin-right: 12px"
                    ><mat-icon [ngStyle]="{ color: getIconColor(gb.bewegung_typ) }">{{
                        getIcon(gb.bewegung_typ)
                    }}</mat-icon></span
                >
                <span style="width: 60px; margin-right: 12px">{{ getBewegungstyp(gb.bewegung_typ) }}</span>
                <span style="margin-right: 12px">{{ gb.datum | date: "dd.MM.yyyy" }}</span>
                <span style="margin-right: 12px">{{ gb.anzahl_tiere }} Tiere</span>
                <span class="spacer"></span>
            </div>
        </li>
    </ul>
</mat-expansion-panel>
